import { Navigate, Route, Routes } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { Login } from '../../pages/auth/login';
import { Register } from '../../pages/auth/register';
import { ForgotPassword } from '../../pages/auth/forgot';


import { AuthLayout } from '../../layouts/auth-layout';
import { ProfileRoute } from '../profileRoute';
// import { CompleteTutorProfile } from '../profile/completeTutorProfile';
import { TutorProfile } from '../profile/tutorProfile';
import { getSession } from '../../store/auth/authActions';
import { Dashboard } from '../../pages/dashboard';
import Chat from '../../pages/chat';
import { CalendarView } from '../../pages/calendar/calendar';
import { Settings } from '../../pages/settings/settings';
import { TutorList } from '../../pages/tutors/tutorList';
import { CourseList } from '../../pages/course/course-list';
import { SwitchTutor } from '../profile/create/switch-tutor';
import { LoadingPage } from '../../pages/general/loading-page';
import { CourseDetails } from '../../pages/course/detail';
import { Wallet } from '../../pages/wallet/wallet';
import { PaymentResult } from '../../pages/course/payment-result';
import { OrderDetail } from '../../pages/course/order-detail';
import { Withdraw } from '../../pages/wallet/withdraw';
import { SettingPreview } from '../../pages/settings/preview';
import { Error404 } from '../../pages/errors/404';
import { PublicRoute } from '../publicRoute/publicRoute';
import { PublicTutorList } from '../../pages/tutors/publicTutorList';
import { PublicTutorProfile } from '../profile/publicTutorProfile';
import { VideoChat } from '../../pages/video/page';
import { ConfirmEmail } from '../auth/confirm-email';
import AuthGuard from '../auth/auth.guard';
import { CreateProfileWizard } from '../profile/create';
import { PrivateLayout } from '../../layouts';
import { NotificationsPage } from '../../pages/notifications/NotificationsPage';

import { 
	COURSES_URL, 
	AUTH_LOGIN_URL, 
	AUTH_REGISTER_URL, 
	AUTH_FORGOT_PASSWORD_URL, 
	AUTH_VERIFY_EMAIL_URL 
} from './routes';

function App() {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true)
	
	useEffect(() => {
		dispatch(getSession())
		.unwrap()
		.then(async (data) => {
			setLoading(false)
		})
		.catch(() =>{
			setLoading(false)
		});

	}, []);

	return (
		<div>
			{loading ? <LoadingPage /> :
			<Layout>
				<Routes>
					<Route element={<AuthGuard />}>
						<Route path='/create/profile' element={<ProfileRoute component={CreateProfileWizard} restricted={true} />} />
						<Route path='/switch/tutor' element={<ProfileRoute component={SwitchTutor} restricted={true} isSwitch={true}/>} />
					
						<Route path={AUTH_LOGIN_URL} element={<AuthLayout restricted={true} component={Login} />} />
						<Route path={AUTH_REGISTER_URL} element={<AuthLayout restricted={true} component={Register} />} />
						<Route path={AUTH_FORGOT_PASSWORD_URL} element={<AuthLayout restricted={true} component={ForgotPassword} />} />
						<Route path={AUTH_VERIFY_EMAIL_URL} element={<AuthLayout restricted={true} component={ConfirmEmail} />} />
						
						<Route path="/" element={<PrivateLayout component={Dashboard} />} />
						<Route path='/404' element={<PrivateLayout restricted={true} component={Error404} />} />
						{/* Post-approval laststep onboarding moved into tutor creation wizard */}
						{/* <Route path='/laststep' element={<PrivateLayout restricted={true} component={CompleteTutorProfile} />} /> */}
						<Route path='/settings' element={<PrivateLayout restricted={true} component={Settings} />} />

						<Route path='/tutors' element={<PrivateLayout restricted={true} component={TutorList} />} />
						<Route path='/tutor/:id' element={<PrivateLayout restricted={true} component={TutorProfile} />} />
						
						<Route path='/chat' element={<PrivateLayout restricted={true} component={Chat} />} />
						<Route path='/chat/:id' element={<PrivateLayout restricted={true} component={Chat} />} />
						
						<Route path='/order/payment/:id' element={<PrivateLayout restricted={true} component={PaymentResult} />} />
						<Route path='/order/detail/:id' element={<PrivateLayout restricted={true} component={OrderDetail} />} />
						
						<Route path='/wallet' element={<PrivateLayout restricted={true} component={Wallet} />} />
						<Route path={`${COURSES_URL}/detail/:id`} element={<PrivateLayout restricted={true} component={CourseDetails} />} />
						<Route path={COURSES_URL} element={<PrivateLayout restricted={true} component={CourseList} />} />
						<Route path="/notifications" element={<PrivateLayout restricted={true} component={NotificationsPage} />} />
					</Route>

					<Route path='/appointment/chat' element={<PrivateLayout restricted={true} component={VideoChat} />} />
					<Route path='/me' element={<PrivateLayout restricted={true} component={SettingPreview} />} />
					<Route path='/calendar' element={<PrivateLayout restricted={true} component={CalendarView} />} />
					<Route path='/withdraw' element={<PrivateLayout restricted={true} component={Withdraw} />} />
					<Route path='/public/tutors' element={<PublicRoute component={PublicTutorList} />} />
					<Route path='/public/tutor/:id' element={<PublicRoute component={PublicTutorProfile} />} />
					
					<Route path="*" element={<Navigate to="/404" replace />} />
				</Routes>
			</Layout>}
		</div>
	);
}

const Layout = ({ children }) => (

	<div className="ioparla-container">
		{children}
	</div>
	
);

export { App };
